import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Box, Link } from '@mui/material';
// configs
import config from '../../config';

// ----------------------------------------------------------------------

const Logo = forwardRef(
    ({ disabledLink = false, sx, Component, ...other }, ref) => {
        const LogoSvg = Component || config.logo;

        const logo = (
            <Box
                ref={ref}
                component="div"
                sx={{
                    marginY: '10px',
                    marginLeft: '10px',
                    display: 'inline-flex',
                    ...sx
                }}
                {...other}
            >
                <LogoSvg />
            </Box>
        );

        if (disabledLink) {
            return <>{logo}</>;
        }

        return (
            <Link to="/" component={RouterLink} sx={{ display: 'contents' }}>
                {logo}
            </Link>
        );
    }
);

Logo.propTypes = {
    sx: PropTypes.object,
    disabledLink: PropTypes.bool,
    Component: PropTypes.elementType
};

export default Logo;
